<template>
	<dms-wrapper :show-label="false" v-bind="{...$attrs, wrapp}" class="frm-activity" :disabled="isDisabled">
		<div v-if="count !== undefined" class="el-input el-input--mini is-disabled input-number">
			<div class="el-input__inner">
				{{ count }}
			</div>
		</div>
		<div class="el-input el-input--mini is-disabled input-label">
			<div class="el-input__inner">
				{{ labelText }}
			</div>
		</div>
		<dms-button-group v-if="hasButtons" :wrap="false">
			<slot name="buttons" />
			<dms-button v-if="hasCreateListener" :disabled="false" :wrapp="false" icon="el-icon-plus" @click="$emit('create')" />
			<dms-button v-if="hasDetailListener" :disabled="false" :wrapp="false" icon="el-icon-arrow-right" @click="$emit('detail')" />
		</dms-button-group>
		<slot />
	</dms-wrapper>
</template>

<script>
import { DmsBaseComponent } from '#components/dms/common/base';
import DmsWrapper from '#components/dms/form/Wrapper.vue';

export default DmsBaseComponent.extend({
	name: 'DmsActivity',
	components: { DmsWrapper },
	props: {
		count: Number,
		wrapp: { type: Boolean, default: true },
	},
	computed: {
		hasDetailListener() {
			return this.$listeners && this.$listeners.detail;
		},
		hasCreateListener() {
			return this.$listeners && this.$listeners.create;
		},
		hasButtons() {
			return !!this.$slots.buttons || this.hasDetailListener || this.hasCreateListener;
		},
	},
});
</script>
